import VNavigationDrawer from './VNavigationDrawer';
export { VNavigationDrawer };
export default VNavigationDrawer;
//# sourceMappingURL=index.js.map